import { productApiUrl } from "API/urls/product.api";
import { axiosInstance } from "configs/axios";

export const fetchProductPmcChecklistApi = async (productLotProcessingId) => {
  try {
    const response = await axiosInstance.get(
      productApiUrl.getPmcChecklist + "/" + productLotProcessingId
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
